// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organisation_card__PHtW4 {
  width: 280px;
}

@media only screen and (max-width: 768px) {
  .organisation_card__PHtW4 {
    width: 100%;
  }
}

.organisation_subTitle__Kw4ee {
  color: var(--mui-palette-grey-800);
  margin-top: 6px;
}

.organisation_linkIconCustom__HuGMK svg rect:first-child {
  fill: transparent;
}

.group:hover .organisation_linkIconCustom__HuGMK {
  background: black !important;
  border-radius: 8px !important;
}

.group:hover .organisation_linkIconCustom__HuGMK rect:first-child {
  fill: black !important;
}

.group:hover .organisation_linkIconCustom__HuGMK path {
  stroke: white !important;
}

.group:hover .organisation_linkIconCustom__HuGMK rect:last-child {
  stroke: black !important;
}`, "",{"version":3,"sources":["webpack://./src/components/organisation/index.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".card {\n  width: 280px;\n}\n\n@media only screen and (max-width: 768px) {\n  .card {\n    width: 100%;\n  }\n}\n\n.subTitle {\n  color: var(--mui-palette-grey-800);\n  margin-top: 6px;\n}\n\n.linkIconCustom svg rect:first-child {\n  fill: transparent;\n}\n\n:global(.group:hover) .linkIconCustom {\n  background: black !important;\n  border-radius: 8px !important;\n}\n\n:global(.group:hover) .linkIconCustom rect:first-child {\n  fill: black !important;\n}\n\n:global(.group:hover) .linkIconCustom path {\n  stroke: white !important;\n}\n\n:global(.group:hover) .linkIconCustom rect:last-child {\n  stroke: black !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `organisation_card__PHtW4`,
	"subTitle": `organisation_subTitle__Kw4ee`,
	"linkIconCustom": `organisation_linkIconCustom__HuGMK`
};
export default ___CSS_LOADER_EXPORT___;
